export default class Slider {
  get DEFAULT_OPTIONS() {
    return {
      wrapperClass: 'slides',
      slideClass: 'slide',
      slideActiveClass: 'is-selected',
      speed: 600,
      slidesPerView: 'auto',
      navigation: {
        prevEl: '.slider-btn-prev',
        nextEl: '.slider-btn-next',
      },
    };
  }

  constructor() {
    this.$sliders = [...document.querySelectorAll('[data-slider]')]
    if (!this.$sliders.length) return;
    this.createSlider();
  }

  createSlider() {
    this.$sliders.forEach((el) => {
      const sliderId = el.dataset.sliderId;
      const slidesPerView = el.dataset.sliderPerView ? parseFloat(el.dataset.sliderPerView) : 'auto';
      const slidesPerGroup = el.dataset.sliderPerGroup ? parseInt(el.dataset.sliderPerGroup) : 1;
      const slidesOffsetBefore = el.dataset.sliderOffsetBefore ? parseInt(el.dataset.sliderOffsetBefore) : 0;
      const slidesOffsetAfter = el.dataset.sliderOffsetAfter ? parseInt(el.dataset.sliderOffsetAfter) : 0;
      const spaceBetween = el.dataset.sliderSpaceBetween ? parseInt(el.dataset.sliderSpaceBetween) : 0;
      const options = {
        ...this.DEFAULT_OPTIONS,
        slidesPerView,
        slidesPerGroup,
        spaceBetween: spaceBetween,
        loop: el.dataset.sliderLoop ? true : false,
        centeredSlides: el.dataset.sliderCentered ? true : false,
        slidesOffsetBefore,
        slidesOffsetAfter,
        pagination: {
          el: `[data-slider-id="${sliderId}"] .slider-paginations`,
          bulletActiveClass: 'is-active',
          clickable: true,
        },
        scrollbar: {
          el: `[data-slider-id="${sliderId}"] .slider-scroll`,
          draggable: true,
        },
      }
      new Swiper(el, options);
    });
  }
}